import { useState } from 'react'
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, TextField,
  Stack, Alert, CircularProgress,
} from '@mui/material'
import { useAgentBuilder } from '../hooks/useAgentBuilder'

const EMPTY_FORM = {
  name: '',
  description: '',
}

export default function AddAgentDialog({ open, onClose, onCreated }) {
  const [form, setForm] = useState(EMPTY_FORM)
  const { createAgent, saving, error, clearError } = useAgentBuilder()

  const set = (key) => (e) =>
    setForm((f) => ({ ...f, [key]: e.target.value }))

  const handleSubmit = async () => {
    if (!form.name.trim()) return
    const agent = await createAgent({
      name: form.name.trim(),
      description: form.description || null,
    })
    if (agent) {
      setForm(EMPTY_FORM)
      clearError()
      onClose()
      onCreated(agent)
    }
  }

  const handleClose = () => {
    setForm(EMPTY_FORM)
    clearError()
    onClose()
  }

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>New Agent</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ mt: 1 }}>
          {error && <Alert severity="error">{error}</Alert>}
          <TextField
            label="Name"
            value={form.name}
            onChange={set('name')}
            required
            fullWidth
            helperText="Unique identifier, e.g. DisputeOrchestrator"
          />
          <TextField
            label="Description"
            value={form.description}
            onChange={set('description')}
            fullWidth
            multiline
            rows={2}
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} disabled={saving}>Cancel</Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          disabled={saving || !form.name.trim()}
          startIcon={saving ? <CircularProgress size={16} /> : null}
        >
          Create
        </Button>
      </DialogActions>
    </Dialog>
  )
}
